import {AnyAction} from 'redux';
import Types from '../../../actions/Types';

import Story from '../../../../domain/entities/response/Story';

export default function reducer(
  state: {[key: number]: Story} = {},
  action: AnyAction,
): {[key: number]: Story} {
  switch (action.type) {
    case Types.ResetWriterCurrentUser:
      return {};
    case Types.IndexResponseStoriesSuccess:
      return {
        ...state,
        ...action.payload.records.reduceRight(
          (obj: {[key: number]: Story}, record: Story) => {
            obj[record.id] = record;
            return obj;
          },
          {},
        ),
      };
    case Types.ShowResponseStorySuccess:
    case Types.UpdateResponseStorySuccess:
      return {
        ...state,
        [action.payload.id]: action.payload,
      };
    default:
      return state;
  }
}
